<template>
  <v-container fluid>
    <v-layout mt-4 row wrap>
      <v-flex xs12 md6>
        <v-checkbox
          :rules="[rules.Recritmentlastthreemonths]"
          label="Recruitment (hired within last three months)"
          v-model="Employment.RecruitmentwithinLastThreeMonths"
          :readonly="disableFields"
        ></v-checkbox>
      </v-flex>

      <v-flex xs12 md6>
        <v-checkbox
          :rules="[rules.RetentionExisitngStaff]"
          label="Retention (existing staff member)"
          v-model="Employment.RetentionExistingStaff"
          :readonly="disableFields"
        ></v-checkbox>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field
          required
          :rules="[rules.weekleydaywork]"
          v-model="Employment.WeeklyDaysAndHoursWorkedatPracticeLocation"
          label="Weekly days and hours worked by healthcare provider at this practice location only"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          row
          required
          :rules="[rules.HCProvideServiceatMultipleLocation]"
          v-model="Employment.HCProvideServiceatMultipleLocation"
          label="Does the healthcare professional provide services at multiple locations?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 v-if="Employment.HCProvideServiceatMultipleLocation==true">
        <v-textarea
          required
          :rules="[rules.IfYesExplainAdditionalPracticeSites]"
          auto-grow
          box
          label="If yes, please complete the Additional Practice Site section for each practice location"
          v-model="Employment.IfYesExplainAdditionalPracticeSites"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          row
          required
          :rules="[rules.HCProvideSpecialCareAtPracticeSite]"
          v-model="Employment.HCProvideSpecialCareAtPracticeSite"
          label="Does the healthcare professional provide specialty care/services at the practice site"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 v-if="Employment.HCProvideSpecialCareAtPracticeSite==true">
        <v-textarea
          box
          required
          :rules="[rules.IfYesHCProvideSpeacialCareAtSite]"
          autoGrow
          name="input-7-1"
          v-model="Employment.IfYesHCProvideSpeacialCareAtSite"
          label="If yes, please describe"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 mt-4>
        <v-text-field
          :rules="[rules.ProposedSalary, rules.NumberOnly]"
          v-model="Employment.ProposedSalary"
          label="List the proposed/current salary for the healthcare professional:"
          :readonly="disableFields"
          prepend-inner-icon="attach_money"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 mt-4>
        <v-textarea
          box
          autoGrow
          name="input-7-1"
          :rules="[rules.BenefitsMalPracticeCoverage]"
          v-model="Employment.BenefitsMalPracticeCoverage"
          label="List the benefits and malpractice coverage provided for the healthcare professional:"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          row
          :rules="[rules.ReduceTheCompensationAsaResultOfWYSLRP]"
          v-model="Employment.ReduceTheCompensationAsaResultOfWYSLRP"
          label="Has the site, or will the site, reduce the healthcare professional’s compensation as a result of
            participation in WY-SLRP?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          row
          :rules="[rules.AggrementbtSiteAndHCBonusPay]"
          v-model="Employment.AggrementbtSiteAndHCBonusPay"
          label="Is there an agreement between the site and the healthcare professional for bonus payments which
            create a service obligation? (e.g., must maintain employment at the site for a specific period of
            time or the funds must be returned to the site)"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 mt-4>
        <v-textarea
          box
          autoGrow
          :rules="[rules.SitePlanAreaUponCompletiontoWYSLRP]"
          name="input-7-1"
          v-model="Employment.DescribetheSitePlanRetainHCServiceAreaUponCompletiontoWYSLRP"
          label="Describe the practice site’s plan to retain the healthcare professional in the service area upon
completion of their service obligation to the WY-SLRP"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Rules from '../validation/rules'
export default {
  name: 'Employment',
  props: {
    Employment: Object,
    disableFields: Boolean
  },
  data() {
    return {
      rules: Rules,
    }
  },
  methods: {},

  components: {},
  watch: {
    Employment: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
  },
}
</script>
<style>
</style>